// ABOUTME: Groups tag rows from the tags named source into the OOHTagGroup
// ABOUTME: structure consumed by the tag-selector filter dropdown.
import {
  type OOHTag,
  type OOHTagGroup,
} from 'app/common/tag-selector/tag-selector.component'
import { type TagRow } from 'app/mobility/ooh/model/tags.model'

// Pins the display order of the known groups; groups not listed here are
// appended after them in alphabetical order.
export const TAG_GROUP_ORDER = [
  'Location',
  'Media Type',
  'Panel Type',
  'Illumination',
]

export function groupTags(rows: TagRow[]): OOHTagGroup[] {
  const groups = new Map<string, OOHTag[]>()

  for (const row of rows) {
    const groupName = row.group_name || 'Other'
    if (!groups.has(groupName)) {
      groups.set(groupName, [])
    }
    groups.get(groupName).push({
      id: row.id,
      name: row.name,
      label: row.label ?? row.name,
    })
  }

  const orderedLabels = [...groups.keys()].sort((a, b) => {
    const orderA = TAG_GROUP_ORDER.indexOf(a)
    const orderB = TAG_GROUP_ORDER.indexOf(b)
    if (orderA !== -1 && orderB !== -1) return orderA - orderB
    if (orderA !== -1) return -1
    if (orderB !== -1) return 1
    return a.localeCompare(b)
  })

  return orderedLabels.map((label) => ({
    label,
    tags: groups.get(label).sort((a, b) => a.label.localeCompare(b.label)),
  }))
}
